import type { Pose } from "./pose.js";

/**
 * Pose base: sentado na vassoura, inclinado para a frente. Os braços ficam aproximados; quem leva as mãos
 * ao cabo é a cinemática inversa do cliente (pesos `grip` dos clipes).
 * Todos os clipes são camadas somadas a esta pose.
 */
export const SEATED: Pose = {
  pelvis: [0, 0, 0],
  spine_01: [22, 0, 0],
  spine_02: [14, 0, 0],
  spine_03: [8, 0, 0],
  neck_01: [-20, 0, 0],
  Head: [-18, 0, 0],
  // Braços: descem da pose em T e vão para a frente segurar o cabo.
  upperarm_l: [0, -62, -58],
  lowerarm_l: [0, -22, -12],
  hand_l: [0, 0, 25],
  upperarm_r: [0, 62, 58],
  lowerarm_r: [0, 22, 12],
  hand_r: [0, 0, -25],
  // Pernas: coxas para a frente, canelas penduradas, pés para trás no apoio.
  thigh_l: [-58, 0, 10],
  calf_l: [118, 0, 0],
  foot_l: [-35, 0, 0],
  thigh_r: [-58, 0, -10],
  calf_r: [118, 0, 0],
  foot_r: [-35, 0, 0],
};
